import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-google-map-dialog-box',
  templateUrl: './google-map-dialog-box.component.html',
  styleUrls: ['./google-map-dialog-box.component.css']
})
export class GoogleMapDialogBoxComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<GoogleMapDialogBoxComponent> ) {} 
  ngOnInit() { }

}
